import ApiService from "@/core/services/api.service";
import state from "./state";

export default {
  /**
   * Fetch Employee Yearly Attendance
   *
   * @param context
   * @param payload
   */
  fetchStaffIndividualEmployeeYearlyAttendanceList(context, payload) {
    ApiService.setHeader();
    return ApiService.query("school/attendance/staff/yearly/individual", {
      params: {
        id: payload.id,
        date: state.filter.date,
      },
    }).then((res) => {
      console.log("Received ", res);
      context.commit(
        "setStaffIndividualEmployeeYearlyAttendanceList",
        res.data.data
      );

      return res;
    });
  },

  /**
   * Change list filter date
   *
   * @param context
   * @param payload
   */
  changeStaffEmployeeYearlyAttendanceListDate(context, payload) {
    const date = payload.date;
    if (date !== null) {
      context.commit("setStaffIndividualEmployeeYearlyAttendanceDate", date);
    }
  },
};
